import { SFDC_STAGE_COLOR, SFDC_STAGE_ORDER } from '../../../utils/sfdcStage';

export default function StageLegend() {
  return (
    <div className="ivt-motion-detail__legend">
      {SFDC_STAGE_ORDER.map((stage) => (
        <div key={stage} className="ivt-motion-detail__legend-item">
          <span
            className="ivt-motion-detail__legend-dot"
            style={{ backgroundColor: SFDC_STAGE_COLOR[stage] ?? '#94a3b8' }}
          />
          <span className="ivt-motion-detail__legend-label">{stage}</span>
        </div>
      ))}
    </div>
  );
}
